import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/uiSupportWebsiteCustomPagesQuery$parameters';

export const HelpCenterSettingsSupportWebsitePagesAppEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-help-center-setting-support-website-pages-app" */ './src/ui'
			),
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => ({
		queries: {
			customPagesQuery: {
				parameters,
				variables: {
					cloudId,
					helpCenterARI: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					NUMBER_OF_PAGES_INITIAL_FETCH: 300,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
